export enum ActionTypes {
    GET_CONTRACTOR = 'GET_CONTRACTOR',
    GET_CONTRACTORS = 'GET_CONTRACTORS',
    GET_REVIEW_CONTRACTOR = 'GET_REVIEW_CONTRACTOR',
}